import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { CLEAR_EDITOR_COMMAND } from 'lexical';
import { forwardRef, useImperativeHandle } from 'react';

export interface EditorControl {
    clear: () => void;
    focus: () => void;
    setEditable: (isEditable: boolean) => void;
    isEditable: () => boolean;
}

export const EditorControlPlugin = forwardRef((props, ref): null => {
    const [editor] = useLexicalComposerContext();

    useImperativeHandle(
        ref,
        () => {
            return {
                clear: () => {
                    editor.dispatchCommand(CLEAR_EDITOR_COMMAND, undefined);
                },
                focus: () => {
                    editor.focus();
                },
                setEditable: (isEditable: boolean) => {
                    editor.setEditable(isEditable);
                },
                isEditable: () => {
                    return editor.isEditable();
                },
            };
        },
        [editor]
    );

    return null;
});
